// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAutoEnrollAccountFundingConfigDto
 */
export interface IAutoEnrollAccountFundingConfigDto {
    /**
     * 
     * @type {number}
     * @memberof IAutoEnrollAccountFundingConfigDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoEnrollAccountFundingConfigDto
     */
    plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoEnrollAccountFundingConfigDto
     */
    auto_enrollment_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoEnrollAccountFundingConfigDto
     */
    per_person_spend_limit_amount?: number;
}

/**
 * Check if a given object implements the IAutoEnrollAccountFundingConfigDto interface.
 */
export function instanceOfIAutoEnrollAccountFundingConfigDto(value: object): value is IAutoEnrollAccountFundingConfigDto {
    return true;
}

export function IAutoEnrollAccountFundingConfigDtoFromJSON(json: any): IAutoEnrollAccountFundingConfigDto {
    return IAutoEnrollAccountFundingConfigDtoFromJSONTyped(json, false);
}

export function IAutoEnrollAccountFundingConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAutoEnrollAccountFundingConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'auto_enrollment_amount': json['auto_enrollment_amount'] == null ? undefined : json['auto_enrollment_amount'],
        'per_person_spend_limit_amount': json['per_person_spend_limit_amount'] == null ? undefined : json['per_person_spend_limit_amount'],
    };
}

export function IAutoEnrollAccountFundingConfigDtoToJSON(json: any): IAutoEnrollAccountFundingConfigDto {
    return IAutoEnrollAccountFundingConfigDtoToJSONTyped(json, false);
}

export function IAutoEnrollAccountFundingConfigDtoToJSONTyped(value?: IAutoEnrollAccountFundingConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'plan_id': value['plan_id'],
        'auto_enrollment_amount': value['auto_enrollment_amount'],
        'per_person_spend_limit_amount': value['per_person_spend_limit_amount'],
    };
}

